"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControllerSignalMappingSchema = exports.AddressingStateSchema = exports.AddressingStateType = exports.ControllerBusAddressSchema = exports.BusAddressingMethodSchema = exports.DeviceSelectSchema = exports.ProtocolAddressSchema = exports.ConfigurableProtocolAddressSchema = exports.ConfigurableProtocolAddressSignalSchema = exports.SelectableProtocolAddressSchema = exports.FixedProtocolAddressSchema = exports.PinState = void 0;
exports.getAddressingStateString = getAddressingStateString;
const zod_1 = require("zod");
const IExternalComponent_1 = require("./IExternalComponent");
var PinState;
(function (PinState) {
    PinState["High"] = "HIGH";
    PinState["Low"] = "LOW";
})(PinState || (exports.PinState = PinState = {}));
exports.FixedProtocolAddressSchema = zod_1.z.object({
    type: zod_1.z.literal('fixed'),
    address: zod_1.z.number(),
});
exports.SelectableProtocolAddressSchema = zod_1.z.object({
    type: zod_1.z.literal('selectable'),
    selectSignalId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    addresses: zod_1.z.object({
        highState: zod_1.z.number(),
        lowState: zod_1.z.number(),
    }),
});
exports.ConfigurableProtocolAddressSignalSchema = zod_1.z.object({
    signalId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    bitPosition: zod_1.z.number(),
    bitValue: zod_1.z.number().optional(),
    activeState: zod_1.z.union([
        zod_1.z.nativeEnum(PinState),
        zod_1.z.object({
            component: zod_1.z.lazy(() => IExternalComponent_1.IExternalComponentSchema),
        }),
    ]),
});
exports.ConfigurableProtocolAddressSchema = zod_1.z.object({
    type: zod_1.z.literal('configurable'),
    baseAddress: zod_1.z.number(),
    configurableSignals: zod_1.z.array(zod_1.z.lazy(() => exports.ConfigurableProtocolAddressSignalSchema)),
});
exports.ProtocolAddressSchema = zod_1.z.discriminatedUnion('type', [
    exports.FixedProtocolAddressSchema,
    exports.SelectableProtocolAddressSchema,
    exports.ConfigurableProtocolAddressSchema,
]);
exports.DeviceSelectSchema = zod_1.z.object({
    selectSignalId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    activeState: zod_1.z.nativeEnum(PinState),
});
exports.BusAddressingMethodSchema = zod_1.z.enum(['protocol', 'select']);
exports.ControllerBusAddressSchema = zod_1.z.object({
    moduleName: zod_1.z.string(),
    signalsToDrive: zod_1.z.array(zod_1.z.lazy(() => exports.ControllerSignalMappingSchema)),
});
var AddressingStateType;
(function (AddressingStateType) {
    AddressingStateType["PinState"] = "pinState";
    AddressingStateType["Address"] = "address";
})(AddressingStateType || (exports.AddressingStateType = AddressingStateType = {}));
exports.AddressingStateSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({ type: zod_1.z.literal(AddressingStateType.PinState), pinState: zod_1.z.nativeEnum(PinState) }),
    zod_1.z.object({ type: zod_1.z.literal(AddressingStateType.Address), address: zod_1.z.number() }),
]);
exports.ControllerSignalMappingSchema = zod_1.z.object({
    controllerSignalId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    state: exports.AddressingStateSchema,
});
function getAddressingStateString(state) {
    if (!state) {
        throw new Error('Addressing state is not defined');
    }
    if ('pinState' in state) {
        return state.pinState;
    }
    return `0x${state.address.toString(16)}`;
}
//# sourceMappingURL=FunctionalAddressing.js.map